// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppEvent, NavItem } from '@interfaces/interfaces';
import { ContentService } from '@services/content.service';
import { NavService } from '@services/nav.service';
import { PermissionsService } from '@services/permissions.service';
import { SettingsService } from '@services/settings.service';
import { UserService } from '@services/user.service';
import { Observable, takeWhile } from 'rxjs';
import { ErrorModalComponent } from 'src/app/modals/error-modal/error-modal.component';

@Component({
    selector: 'buyer-side-nav',
    templateUrl: './buyer-side-nav.component.html',
    styleUrls: ['./buyer-side-nav.component.scss'],
})
export class BuyerSideNavComponent implements OnDestroy {
    private isComponentAlive: boolean = true;
    public menu$: Observable<NavItem[]>;

    constructor(
        private readonly navService: NavService,
        private readonly userService: UserService,
        private readonly dialog: MatDialog,
        private readonly permissionService: PermissionsService,
        private readonly contentService: ContentService,
        readonly settingsService: SettingsService
    ) {
        this.menu$ = this.navService.getSideNavMenu();
    }

    public logOut() {
        this.navService.accountType = null;
        this.userService.logOut();
    }

    public eventHandler(event: AppEvent): void {
        if ('navigate' !== event.context) {
            return;
        }

        if (event.data.route.includes('login')) {
            this.logOut();
            return;
        }
        if (this.permissionService.hasPermission(event.data?.permissions?.permissionIds)) {
            this.navService.setSelectedRoute('main', event.data);
            this.navService.setSelectedRouteByURL(event.data?.route);
        } else {
            this.contentService
                .permissionsMissingError()
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((message) => {
                    this.dialog.open(ErrorModalComponent, {
                        width: '700px',
                        data: {
                            title: 'Access Restricted',
                            message,
                        },
                    });
                });
        }
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
